export const ContactUsUrl = () => '/ClubLink/ContactUs';
